module.exports = __webpack_public_path__ + "img/multiplier_1_win.59c0a440.png";